import React, { useState } from 'react';
import InfoView from 'components/InfoView';
import Widget from "components/Widget";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Paper, withStyles, Button, TextField } from "@material-ui/core";
import {requestDeleteAccount} from '../actions/Auth';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom'

class RequestDeleteAccount extends React.Component {
  constructor() {
    super();
    this.state = {
      email: ''
    }
  }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     if (!validateEmail(email)) {
    //         alert('Please enter a valid email address.');
    //         return;
    //     }
        
    //     this.props.requestDeleteAccount({email});
    // };

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.deleteAccountStatus !== this.props.deleteAccountStatus) {
        let deleteAccountStatus = this.props.deleteAccountStatus || null
        if (deleteAccountStatus != null) {
          if (deleteAccountStatus) {
            alert("Thank you for your request. Our team will review it first before proceeding and will get back to you soon.")
          } else {
            alert("Something went wrong, please try again")
          }

          this.setState({email: ""})
          window.location.reload();
        }
      }
    }

    validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    render() {
      const {
        email,
      } = this.state;
    return (
    <div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Jambo">
              <img src={require("assets/images/logo_new.png")} alt="BetterHealth" title="BetterHealth" style={{maxWidth: 100}} />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={"Email address"}
                    fullWidth
                    onChange={(event) => this.setState({email: event.target.value})}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    id="email"
                    name="email"
                    value={email}
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button onClick={() => {
                      if (!this.validateEmail(email)) {
                        alert('Please enter a valid email address.');
                        return;
                      }

                      this.props.requestDeleteAccount({ email });
                    }} variant="contained" color="primary">
                      Request Delete Account
                    </Button>

                    
                  </div>
                </fieldset>
              </form>
            </div>
          </div>

        </div>
        <InfoView />
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {userType, deleteAccountStatus} = auth;
  return {userType, deleteAccountStatus}
};

export default connect(mapStateToProps, {requestDeleteAccount})(RequestDeleteAccount);
